export default __webpack_public_path__ + "static/media/Whats_the_Point_instructions.68611cb0.png";